import {
  ArrowDownFromLine,
  BowArrow,
  Download,
  Flag,
  Group,
  Hammer,
  Hourglass,
  Pointer,
  Swords,
  Upload,
} from "lucide-react";
import type { ReactNode } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import type { BoardCursorMode } from "#/game/selection/types";

export const BOARD_CURSOR_ATTACK_FILL = "#dc2626";
export const BOARD_CURSOR_WAIT_FILL = "#d97706";

function buildCursor(icon: ReactNode, color: string): string {
  const svg = renderToStaticMarkup(
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <circle cx="14" cy="14" r="11" fill={color} stroke="#ffffff" strokeWidth="1" />
      <g transform="translate(7 7)">{icon}</g>
    </svg>,
  );
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}") 4 4, auto`;
}

const CURSOR_BY_MODE: Record<Exclude<BoardCursorMode, "default">, string> = {
  move: buildCursor(
    <ArrowDownFromLine size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#2563eb",
  ),
  attack: buildCursor(
    <Swords size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    BOARD_CURSOR_ATTACK_FILL,
  ),
  "attack-indirect": buildCursor(
    <BowArrow size={14} fill="none" stroke="#ffffff" strokeWidth={2.25} />,
    BOARD_CURSOR_ATTACK_FILL,
  ),
  capture: buildCursor(
    <Flag size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#16a34a",
  ),
  wait: buildCursor(
    <Hourglass size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    BOARD_CURSOR_WAIT_FILL,
  ),
  build: buildCursor(
    <Hammer size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#7c3aed",
  ),
  join: buildCursor(
    <Group size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#0f766e",
  ),
  load: buildCursor(
    <Upload size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#0369a1",
  ),
  download: buildCursor(
    <Download size={14} fill="#ffffff" stroke="#ffffff" strokeWidth={2.25} />,
    "#0369a1",
  ),
  select: buildCursor(
    <Pointer size={14} fill="none" stroke="#ffffff" strokeWidth={2.25} />,
    "#475569",
  ),
};

export function getCanvasCursor(cursorMode: BoardCursorMode): string {
  return cursorMode === "default" ? "default" : CURSOR_BY_MODE[cursorMode];
}
